const items = [
  "Atención",
  "Emoción",
  "Confianza",
  "Precio",
  "Fricción",
  "Memoria",
  "Percepción digital",
  "Decisión",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={item} className="flex items-center">
        <span
          className={`whitespace-nowrap px-8 font-editorial text-4xl italic md:text-6xl ${
            i % 2 === 0 ? "text-lilac/70" : "text-stroke-faint"
          }`}
        >
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-magenta/70" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section
    aria-hidden
    className="relative overflow-hidden border-y border-white/10 bg-wine/40 py-8"
    data-testid="editorial-marquee"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </section>
);

export default Marquee;
